import {
    FETCH_FOLLOWED_COLLECTION_REQUEST,
    FETCH_FOLLOWED_COLLECTION_SUCCESS,
    FETCH_FOLLOWED_COLLECTION_FAILURE,
  } from '../constants/playlistConstants';
  
  const initialState = { data: [], errors: [], loading: false };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_FOLLOWED_COLLECTION_REQUEST:
        return { ...state, loading: true };
      case FETCH_FOLLOWED_COLLECTION_SUCCESS:
        return { ...state, loading: false, data: action.payload, errors: [] };
      case FETCH_FOLLOWED_COLLECTION_FAILURE:
        return { ...state, loading: false, errors: action.errors };
      default:
        return state;
    }
  };
  
  export default reducer;
  